module.exports = __webpack_public_path__ + "static/official_side-4c7953a24c62091a4e5376eea09642be.jpg";